import React, { useContext, useMemo, useState, useEffect } from 'react';
import { Widget, usePromise, MasterDetailForm, FormTextArea, Button, CrudContext, useRouter, Icon } from '@digital/ui';
import { Collapse, Table, Input, Select, Icon as IconAntD, Modal, Tooltip } from 'antd';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './custom.css';
import TotalizadorMedicao from '../TotalizadorMedicao';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';

import {
  GetAllItensDaMedicoes,
  GetObterMedicaoPorId,
  MedicaoEdit,
  updatePeriodoMedicao,
  AprovarDadosBM,
  ReconfirmarQuantidadeBm,
  ReprovarAnaliseQuantitativaBm,
  ConfirmaQuantidadeBm,
  ExportBoletimLinhaBm,
  UpdateAprovarReprovar,
  GetAllTotalizarMedicao,
  AprovarAnaliseQuantitativaBm,
  ReprovarQuantidadesDoPeriodo,
  AprovarQuantidadesDoPeriodo,
  ReprovarRessalvaQuantidadeBm,
  AprovarRessalvaQuantidadeBm,
  AnalisouRessalvaReenviouBM,
  ReprovarDadosBM,
} from '@app/api/boletimMedicao';

import ModalComentario from './ModalComentario';
import { currencyFormat, currencyParser } from '@app/helpers/numbers';
import { hasPermission } from '@app/helpers/permissions';
import ModalAprovacaoComResalvaAnaliseQuantitativa from './ModalAprovacaoComResalvaAnaliseQuantitativa';
import ModalAnexo from './ModalAnexo';
import { getLoggedIsMRN } from '@app/helpers';
import { useRecoilState } from 'recoil';
import { medicaoSelectedState } from '../atoms';

interface MedicaoFormProps {
  onUpdate: () => any;
  onUpdatePage: () => any;
  atualizarFormularioAbas: () => any;
  atualizarFormulario: boolean;
  atualizarSla: boolean;
  usuarioPodeEditar: boolean;

  usuarioLogadoGestorDoContratoMrn: boolean;
  usuarioLogadoFiscalDoContratoMrn: boolean;
  usuarioLogadoFiscalAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorDoContratoMrn: boolean;
  usuarioLogadoFiscalDoContratoFornecedor: boolean;
  usuarioLogadoGestorDoContratoFornecedor: boolean;
  usuarioLogadoTecnicoMedicaoMrn: boolean;

  usuarioResponsavelDiretoriaProp: boolean;
  usuarioResponsavelAreaProp: boolean;
  usuarioResponsavelDepartamentoProp: boolean;

  codigoStatusMedicao: number;
  onCreateAba: () => any;
  onRemoveAba: () => any;
}

const Medicao = (props: MedicaoFormProps) => {
  const {
    atualizarSla,
    onUpdatePage,
    atualizarFormulario,
    usuarioLogadoGestorDoContratoMrn,
    usuarioLogadoFiscalDoContratoMrn,
    usuarioLogadoFiscalAlternativoDoContratoMrn,
    usuarioLogadoFiscalDoContratoFornecedor,
    usuarioLogadoGestorDoContratoFornecedor,
    usuarioLogadoTecnicoMedicaoMrn,
    onCreateAba,
    onRemoveAba,
  } = props;

  console.log(props)

  const { history } = useRouter();
  const [medicaoSelected, setMedicaoSelected] = useRecoilState(medicaoSelectedState);

  useEffect(() => {
    onRemoveAba();
  }, [medicaoSelected]);

  const [fullScreen, setFullScreen] = useState(false);

  const [itemAdded, setItemAdded] = useState();
  const [hasBtnAprovarDadosBM, setBtnAprovarDadosBM] = useState(false);
  const [hasbtnReprovarOuAprovarQuantidadeDoPeriodo, setReprovarOuAprovarQuantidadeDoPeriodo] = useState(false);

  const [hasBtnConfirmarQuantidadeDoBm, setBtnConfirmarQuantidadeDoBm] = useState(false);
  const [hasBtnAprovarRessalvaQuantidadeDoBm, setBtnAprovarRessalvaQuantidadeDoBm] = useState(false);
  const [hasBtnReprovarRessalvaQuantidadeDoBm, setBtnReprovarRessalvaQuantidadeDoBm] = useState(false);
  const [hasBtnAnalisouRessalvaReenviouBM, setBtnAnalisouRessalvaReenviouBM] = useState(false);
  const [hasBtnAprovarAnaliseQuantitativaBm, setBtnAprovarAnaliseQuantitativaBm] = useState(false);
  const [hasBtnReprovarAnaliseQuantitativaBm, setBtnReprovarAnaliseQuantitativaBm] = useState(false);
  const [hasBtnAprovarComRessalvaAnaliseQuantitativa, setBtnAprovarComRessalvaAnaliseQuantitativa] = useState(false);
  const [hasBtnRefutarAnaliseQuantitativa, setBtnRefutarAnaliseQuantitativa] = useState(false);
  const [hasBtnReconfirmarQuantidadeBm, setBtnReconfirmarQuantidadeBm] = useState(false);

  const [recarregarBotoesGrid, setRecarregarBotoesGrid] = useState(false);

  const [inclusaoValor, setinclusaoValor] = useState();
  const [editAnterior, seteditAnterior] = useState(false);
  const [idEdit, setidEdit] = useState();

  const [recarregarBotoesBm, setrecarregarBotoesBm] = useState(false);
  const [valorAlterado, setValorAlterado] = useState();

  const [codStatusMedicao, setcodigoStatusMedicao] = useState(0);

  const [valoresContratoCriacaoMedicao, setvaloresContratoCriacaoMedicao] = useState('0');
  const [valoresMedicaoAnterior, setvaloresMedicaoAnterior] = useState('0');
  const [valoresMedicaoPeriodo, setvaloresMedicaoPeriodo] = useState('0');
  const [valoresMedicaoAcumulado, setvaloresMedicaoAcumulado] = useState('0');
  const [valoreMedicaoSaldo, setvaloreMedicaoSaldo] = useState('0');

  const [expandedRows, setExpandedRows] = useState(['']);
  const [expandableRows, setExpandableRows] = useState(['']);
  const [btnExpandRows, setBtnExpandRows] = useState(true);
  const [medicaoConfirmada, setMedicaoConfirmada] = useState<boolean>();
  const [canChangeCancelarDropdown, setCanChangeCancelarDropdown] = useState(false);

  const [showCollunsTabelaMedicao, setShowCollunsTabelaMedicao] = useState(false);
  const [showCollunsTabelaMedicaoValor, setShowCollunsTabelaMedicaoValor] = useState(false);
  const [aprovadoComRessalva, setAprovadoComRessalva] = useState(false);

  const obterTotalMedicao = () => {
    GetAllTotalizarMedicao(medicaoSelected.id)
      .then(data => {
        if (data) {
          if (data.medicaoAnterior != undefined) {
            setvaloresMedicaoAnterior(currencyFormat(data.medicaoAnterior));
          }

          if (data.medicaoPeriodo != undefined) {
            setvaloresMedicaoPeriodo(currencyFormat(data.medicaoPeriodo));
          }

          if (data.medicaoAcumulado != undefined) {
            setvaloresMedicaoAcumulado(currencyFormat(data.medicaoAcumulado));
          }
          if (data.medicaoSaldo != undefined) {
            setvaloreMedicaoSaldo(currencyFormat(data.medicaoSaldo));
          }
          if (data.medicaoValorContratoCriacao != undefined) {
            setvaloresContratoCriacaoMedicao(currencyFormat(data.medicaoValorContratoCriacao));
          }
        }
      });
  };

  const calculateDefaultExpandedRowKeys = (data: any[]) => {
    let keys: string[] = [];
    const mapRowKeys = (source: any[]) => {
      source.forEach(element => {
        if (element.children.length !== 0) {
          mapRowKeys(element.children);
          keys.push(element.id);
        }
      });
    };
    mapRowKeys(data);
    return keys;
  };

  const toggleEdit = (record: any) => {
    setidEdit(record.id);
    seteditAnterior(true);
  };

  const save = (record: any, e: any) => {
    let valor = e.target.value;

    if(!valor) valor = 0;

    let form = new FormData();
    form.append('id', record.id);
    form.append('qt_bl_periodo', valor);

    updatePeriodoMedicao(record.id, form)
      .then(data => {
        if (data) {
          if (data.valid) {
            seteditAnterior(false);
            setinclusaoValor('');
            setinclusaoValor(true);
            obterTotalMedicao();
          }
        }
        return data;
      });
  };
  const cancelar = () => {
    seteditAnterior(false);
  };

  const AprovarOuReprovar = (id: any, value: any) => {
    if (value != null) {
      let form = new FormData();
      form.append('id', id);
      form.append('Acao', value);

      UpdateAprovarReprovar(form)
        .then(data => {
          if (data) {
            setRecarregarBotoesGrid(false);
            setRecarregarBotoesGrid(true);
          }
          return data;
        });
    }
  };

  const [getAllItensDaMedicoes] = usePromise(
    () =>
      medicaoSelected
        ? GetAllItensDaMedicoes(medicaoSelected.id)
          .then(data => {
            if (data) {
              if (expandableRows[0] === '') setExpandableRows(calculateDefaultExpandedRowKeys(data));
            }
            return data;
          })
        : Promise.resolve(undefined),
    [itemAdded, inclusaoValor, medicaoSelected, atualizarSla],
    [],
  );

  useEffect(() => {
    if (!btnExpandRows) setExpandedRows(expandableRows);
    else setExpandedRows([]);
  }, [btnExpandRows, expandableRows]);

  const pqActionMedicao = useMemo(() => {
    const actions = [];

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_CONFIRMAR_QUANTIDADES_DO_BM']) &&
      hasBtnConfirmarQuantidadeDoBm &&
      (usuarioLogadoGestorDoContratoMrn === true ||
        usuarioLogadoFiscalDoContratoMrn === true ||
        usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
        usuarioLogadoFiscalDoContratoFornecedor === true ||
        usuarioLogadoGestorDoContratoFornecedor === true)
    ) {
      actions.push(
        <Button
          type="success"
          icon="commons-checked"
          onClick={() => {
            ConfirmaQuantidadeBm(medicaoSelected.id).then((data: any) => {
              if (data) {
                if (data.valid) {
                  onUpdatePage();
                } else {
                  if (data.notifications.filter((item: any) => item.property === 'HasLinhaPendente')[0] != undefined) {
                    Modal.confirm({
                      title: 'Linhas do BM pendentes',
                      content:
                        'Não é possível avançar o processo. Foram identificadas linhas com pendência de lançamento e aprovação.',
                      cancelText: 'Cancelar',
                      onCancel: () => { },
                      okText: 'Visualizar pendências',
                      onOk: () => {
                        setFullScreen(false);
                        onCreateAba();
                        history.push(`/boletimDeMedicoes/detail/${medicaoSelected.id}/pendencias`);
                      },
                    });
                  }
                }
              }
            });
          }}>
          SUBMETER
        </Button>,
      );
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_DADOS_DO_BM']) &&
      hasBtnAprovarDadosBM === true &&
      usuarioLogadoGestorDoContratoMrn === true
    ) {
      actions.push(
        <Button
          type="success"
          icon="hands-thumbs_up"
          onClick={() => {
            AprovarDadosBM(medicaoSelected.id)
              .then(data => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  }
                }
              });
          }}>
          APROVAR {/* Aprovar dados do BM */}
        </Button>,
      );
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_DADOS_DO_BM']) &&
      hasBtnAprovarDadosBM === true &&
      usuarioLogadoGestorDoContratoMrn === true
    ) {
      actions.push(
        <Button
          type="danger"
          icon="hands-thumbs_up"
          onClick={() => {
            ReprovarDadosBM(medicaoSelected.id)
              .then(data => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  }
                }
              });
          }}>
          REPROVAR {/* Reprovar dados do BM */}
        </Button>,
      );
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_CONFIRMAR_QUANTIDADES_DO_BM']) &&
      hasBtnAprovarRessalvaQuantidadeDoBm &&
      usuarioLogadoGestorDoContratoMrn === true
    ) {
      actions.push(
        <Tooltip title="Confirmar a ressalva quantitativa e reenviar o BM para o fornecedor">
          <Button
            type="success"
            icon="commons-checked"
            onClick={() => {
              AprovarRessalvaQuantidadeBm(medicaoSelected.id).then((data: any) => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  } else {
                    if (
                      data.notifications.filter((item: any) => item.property === 'HasLinhaPendente')[0] != undefined
                    ) {
                      Modal.confirm({
                        title: 'Linhas do BM pendentes',
                        content:
                          'Não é possível avançar o processo. Foram identificadas linhas com pendência de lançamento e aprovação.',
                        cancelText: 'Cancelar',
                        onCancel: () => { },
                        okText: 'Visualizar pendências',
                        onOk: () => {
                          setFullScreen(false);
                          onCreateAba();
                          history.push(`/boletimDeMedicoes/detail/${medicaoSelected.id}/pendencias`);
                        },
                      });
                    }
                  }
                }
              });
            }}>
            APROVAR RESSALVA
          </Button>
        </Tooltip>,
      );
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_CONFIRMAR_QUANTIDADES_DO_BM']) &&
      hasBtnReprovarRessalvaQuantidadeDoBm &&
      usuarioLogadoGestorDoContratoMrn === true
    ) {
      actions.push(
        <Tooltip title="Discordar da ressalva quantitativa e devolver o processo para o fiscal MRN">
          <Button
            type="danger"
            icon="commons-checked"
            onClick={() => {
              ReprovarRessalvaQuantidadeBm(medicaoSelected.id).then((data: any) => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  } else {
                    if (
                      data.notifications.filter((item: any) => item.property === 'HasLinhaPendente')[0] != undefined
                    ) {
                      Modal.confirm({
                        title: 'Linhas do BM pendentes',
                        content:
                          'Não é possível avançar o processo. Foram identificadas linhas com pendência de lançamento e aprovação.',
                        cancelText: 'Cancelar',
                        onCancel: () => { },
                        okText: 'Visualizar pendências',
                        onOk: () => {
                          setFullScreen(false);
                          onCreateAba();
                          history.push(`/boletimDeMedicoes/detail/${medicaoSelected.id}/pendencias`);
                        },
                      });
                    }
                  }
                }
              });
            }}>
            REPROVAR RESSALVA
          </Button>
        </Tooltip>,
      );
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_CONFIRMAR_QUANTIDADES_DO_BM']) &&
      hasBtnAnalisouRessalvaReenviouBM &&
      usuarioLogadoGestorDoContratoFornecedor === true
    ) {
      actions.push(
        <Button
          type="success"
          icon="commons-checked"
          onClick={() => {
            AnalisouRessalvaReenviouBM(medicaoSelected.id).then((data: any) => {
              if (data) {
                if (data.valid) {
                  onUpdatePage();
                }
              }
            });
          }}>
          SUBMETER
        </Button>,
      );
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_ANALISE_QUANTITATIVA_DO_BM'])) {
      if (
        hasBtnAprovarAnaliseQuantitativaBm &&
        (usuarioLogadoGestorDoContratoMrn === true ||
          usuarioLogadoFiscalDoContratoMrn === true ||
          usuarioLogadoFiscalAlternativoDoContratoMrn === true)
      ) {
        actions.push(
          <Button
            type="success"
            icon="hands-thumbs_up"
            onClick={() => {
              AprovarAnaliseQuantitativaBm(medicaoSelected.id)
                .then(data => {
                  if (data) {
                    if (data.valid) {
                      onUpdatePage();
                    } else {
                      if (data.notifications.filter(item => item.property === 'HasLinhaPendente')[0] != undefined) {
                        Modal.confirm({
                          title: 'Linhas do BM pendentes',
                          content:
                            'Não é possível avançar o processo. Foram identificadas linhas com pendência de lançamento e aprovação.',
                          cancelText: 'Cancelar',
                          onCancel: () => { },
                          okText: 'Visualizar pendências',
                          onOk: () => {
                            setFullScreen(false);
                            onCreateAba();
                            history.push(`/boletimDeMedicoes/detail/${medicaoSelected.id}/pendencias`);
                          },
                        });
                      }
                    }
                  }
                });
            }}>
            APROVAR {/* Aprovar análise quantitativa do BM */}
          </Button>,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_REPROVAR_ANALISE_QUANTITATIVA_DO_BM'])) {
      if (
        hasBtnReprovarAnaliseQuantitativaBm &&
        (usuarioLogadoGestorDoContratoMrn === true ||
          usuarioLogadoFiscalDoContratoMrn === true ||
          usuarioLogadoFiscalAlternativoDoContratoMrn === true)
      ) {
        actions.push(
          <Button
            type="danger"
            icon="hands-thumbs_down"
            onClick={() => {
              ReprovarAnaliseQuantitativaBm(medicaoSelected.id)
                .then(data => {
                  if (data) {
                    if (data.valid) {
                      onUpdatePage();
                    }
                  }
                });
            }}>
            REPROVAR {/* Reprovar análise quantitativa do BM */}
          </Button>,
        );
      }
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_RECONFIRMAR_QUANTIDADES_DO_BM']) &&
      (usuarioLogadoFiscalDoContratoFornecedor === true || usuarioLogadoGestorDoContratoFornecedor === true)
    ) {
      if (hasBtnReconfirmarQuantidadeBm) {
        actions.push(
          <Button
            type="success"
            icon="hands-thumbs_up"
            onClick={() => {
              ReconfirmarQuantidadeBm(medicaoSelected.id)
                .then(data => {
                  if (data) {
                    if (data.valid) {
                      onUpdatePage();
                    }
                  }
                });
            }}>
            SUBMETER{/* Reconfirmar Quantidades do BM */}
          </Button>,
        );
      }
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_QUANTIDADES_DO_PERIODO']) &&
      usuarioLogadoGestorDoContratoFornecedor === true
    ) {
      if (hasbtnReprovarOuAprovarQuantidadeDoPeriodo) {
        actions.push(
          <Button
            type="success"
            icon="hands-thumbs_up"
            onClick={() => {
              AprovarQuantidadesDoPeriodo(medicaoSelected.id)
                .then(data => {
                  if (data) {
                    if (data.valid) {
                      onUpdatePage();
                    }
                  }
                });
            }}>
            APROVAR {/* Aprovar quantidades do período */}
          </Button>,
        );
      }
    }

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_REPROVAR_QUANTIDADES_DO_PERIODO']) &&
      usuarioLogadoGestorDoContratoFornecedor === true
    ) {
      if (hasbtnReprovarOuAprovarQuantidadeDoPeriodo) {
        actions.push(
          <Button
            type="danger"
            icon="hands-thumbs_down"
            onClick={() => {
              ReprovarQuantidadesDoPeriodo(medicaoSelected.id)
                .then(data => {
                  if (data) {
                    if (data.valid) {
                      onUpdatePage();
                    }
                  }
                });
            }}>
            REPROVAR  {/* Aguardando Aceite do BM – Gestor Fornecedor */}
          </Button>,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_COM_RESSALVA_A_ANALISE_QUANTITATIVA_DO_BM'])) {
      if (
        hasBtnAprovarComRessalvaAnaliseQuantitativa &&
        (usuarioLogadoGestorDoContratoMrn === true ||
          usuarioLogadoFiscalDoContratoMrn === true ||
          usuarioLogadoFiscalAlternativoDoContratoMrn === true)
      ) {
        actions.push(
          <ModalAprovacaoComResalvaAnaliseQuantitativa
            onCreateAba={onCreateAba}
            history={history}
            id={medicaoSelected.id}
            atualizarAbas={onUpdatePage}
          />,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_EXPORTAR'])) {
      actions.push(
        <Button
          type="primary"
          className="ant-btn-success"
          icon="files-ms_excel"
          onClick={() => {
            ExportBoletimLinhaBm(medicaoSelected.id);
          }}>
          Exportar
        </Button>,
      );
    }

    return actions;
  }, [getAllItensDaMedicoes, recarregarBotoesGrid, atualizarSla, btnExpandRows]);

  const [geralData] = usePromise(
    () =>
      medicaoSelected
        ? GetObterMedicaoPorId(medicaoSelected.id)
          .then(data => {
            if (data) {
              setcodigoStatusMedicao(data.statusCodigo);
              if (data.confirmada === undefined) setCanChangeCancelarDropdown(true);
              else setCanChangeCancelarDropdown(false);
              setMedicaoConfirmada(data.confirmada);

              if (data.confirmarQuantidadeDoBm) {
                setBtnConfirmarQuantidadeDoBm(true);
              } else {
                setBtnConfirmarQuantidadeDoBm(false);
              }
              if (data.aprovarRessalvaQuantidadeDoBm) {
                setBtnAprovarRessalvaQuantidadeDoBm(true);
              } else {
                setBtnAprovarRessalvaQuantidadeDoBm(false);
              }
              if (data.reprovarRessalvaQuantidadeDoBm) {
                setBtnReprovarRessalvaQuantidadeDoBm(true);
              } else {
                setBtnReprovarRessalvaQuantidadeDoBm(false);
              }
              if (data.analisouRessalvaReenviouBM) {
                setBtnAnalisouRessalvaReenviouBM(true);
              } else {
                setBtnAnalisouRessalvaReenviouBM(false);
              }
              if (data.aprovarAnaliseQuantitativaBm) {
                setBtnAprovarAnaliseQuantitativaBm(true);
              } else {
                setBtnAprovarAnaliseQuantitativaBm(false);
              }
              if (data.reprovarAnaliseQuantitativaBm) {
                setBtnReprovarAnaliseQuantitativaBm(true);
              } else {
                setBtnReprovarAnaliseQuantitativaBm(false);
              }

              if (data.aprovarComRessalvaAnaliseQuantitativa === true && data.mostrarBotaoAprovarComResalva === true) {
                setBtnAprovarComRessalvaAnaliseQuantitativa(true);
              } else {
                setBtnAprovarComRessalvaAnaliseQuantitativa(false);
              }
              if (data.refutarAnaliseQuantitativa) {
                setBtnRefutarAnaliseQuantitativa(true);
              } else {
                setBtnRefutarAnaliseQuantitativa(false);
              }
              if (data.reconfirmarQuantidadeBm) {
                setBtnReconfirmarQuantidadeBm(true);
              } else {
                setBtnReconfirmarQuantidadeBm(false);
              }

              if (data.aprovarDadosBM) {
                setBtnAprovarDadosBM(true);
              } else {
                setBtnAprovarDadosBM(false);
              }

              if (data.reprovarQuantidadeDoPeriodo) {
                setReprovarOuAprovarQuantidadeDoPeriodo(true);
              } else {
                setReprovarOuAprovarQuantidadeDoPeriodo(false);
              }

              if (data.aprovadoComRessalva) {
                setAprovadoComRessalva(true);
              } else {
                setAprovadoComRessalva(false);
              }

              obterTotalMedicao();
            }

            setRecarregarBotoesGrid(false);
            setRecarregarBotoesGrid(true);
            return data;
          })
        : Promise.resolve(undefined),
    [medicaoSelected, itemAdded, recarregarBotoesBm, atualizarSla, atualizarFormulario],
    {} as MedicaoEdit,
  );

  const CarregarGrid = () => {
    setItemAdded(null);
    setItemAdded(true);
  };

  const columnRemove = 'science-minus';
  const columnAdd = 'ui-add';

  const columsMedicaoNovo = useMemo(() => {
    const novaColumsMedicao = ([] = new Array());
    novaColumsMedicao.push({
      title: 'Itens do Contrato',
      className: 'item-contrato-coluna',
      children: [
        {
          title: column => {
            return (
              <>
                Item
                <Tooltip title={btnExpandRows ? 'Expandir Linhas' : 'Contrair Linhas'}>
                  <Button
                    onClick={() => {
                      setBtnExpandRows(!btnExpandRows);
                    }}
                    name="btnExpandRows"
                    title=""
                    type="link"
                    icon={btnExpandRows ? 'ui-add' : 'science-minus'}
                  />
                </Tooltip>
              </>
            );
          },
          dataIndex: 'item',
          key: 'item',
          className: 'item-contrato-coluna',
        },
        {
          title: 'Descrição',
          dataIndex: 'descricao',
          key: 'descricao',
          className: 'item-contrato-coluna',
        },
        {
          title: 'Unidade',
          dataIndex: 'unidade',
          key: 'unidade',
          className: 'item-contrato-coluna',
        },
        {
          title: 'Preço',
          dataIndex: 'preco',
          key: 'preco',
          className: 'item-contrato-coluna',
        },
      ],
    });

    if (showCollunsTabelaMedicao === true) {
      novaColumsMedicao.push({
        //title: 'QTD BM',
        className: 'quantidade-boletim-medicao-coluna',
        title: column => {
          return (
            <>
              QTD BM
              <Tooltip title={showCollunsTabelaMedicao ? 'Contrair Colunas' : 'Expandir Colunas'}>
                <Button
                  onClick={() => {
                    setShowCollunsTabelaMedicao(!showCollunsTabelaMedicao);
                  }}
                  name="btnMostrarEsconder"
                  title={showCollunsTabelaMedicao ? '' : ''}
                  type="link"
                  icon={showCollunsTabelaMedicao ? columnRemove : columnAdd}
                />
              </Tooltip>
            </>
          );
        },
        children: [
          {
            title: 'Período',
            dataIndex: 'qt_bl_periodo',
            key: 'qt_bl_periodo',
            className: 'quantidade-boletim-medicao-coluna',
            render: (text, record, index) => {
              if (
                record.editable === true &&
                record.usuarioPodeAlterarDados === true &&
                (codStatusMedicao === 1 ||
                  codStatusMedicao === 3 ||
                  (codStatusMedicao === 5 && record.incontroverso) ||
                  codStatusMedicao === 7 ||
                  codStatusMedicao === 8 ||
                  codStatusMedicao === 9 ||
                  codStatusMedicao === 10 ||
                  codStatusMedicao === 11 ||
                  codStatusMedicao === 12 ||
                  codStatusMedicao === 13 ||
                  codStatusMedicao === 14)
              ) {
                if (
                  editAnterior &&
                  record.id === idEdit &&
                  hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) &&
                  (usuarioLogadoGestorDoContratoMrn === true ||
                    usuarioLogadoFiscalDoContratoMrn === true ||
                    usuarioLogadoTecnicoMedicaoMrn === true ||
                    usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
                    ((usuarioLogadoFiscalDoContratoFornecedor === true ||
                      usuarioLogadoGestorDoContratoFornecedor === true) &&
                      (codStatusMedicao === 1 || codStatusMedicao === 3 || codStatusMedicao === 14)))
                ) {
                  return (
                    <Input
                      name="qt_bl_periodo"
                      formatter={currencyFormat}
                      parser={currencyParser}
                      onBlur={() => cancelar()}
                      onPressEnter={e => save(record, e)}
                      defaultValue={record.qt_bl_periodo}
                      required
                      ref={node => {
                        setValorAlterado(node);
                      }}
                    />
                  );
                } else {
                  if (
                    hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) &&
                    (codStatusMedicao === 1 ||
                      codStatusMedicao === 3 ||
                      (codStatusMedicao === 5 && record.incontroverso) ||
                      codStatusMedicao === 7 ||
                      codStatusMedicao === 8 ||
                      codStatusMedicao === 9 ||
                      codStatusMedicao === 10 ||
                      codStatusMedicao === 11 ||
                      codStatusMedicao === 12 ||
                      codStatusMedicao === 13 ||
                      codStatusMedicao === 14) &&
                    (usuarioLogadoGestorDoContratoMrn === true ||
                      usuarioLogadoFiscalDoContratoMrn === true ||
                      usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
                      usuarioLogadoTecnicoMedicaoMrn === true ||
                      ((usuarioLogadoFiscalDoContratoFornecedor === true ||
                        usuarioLogadoGestorDoContratoFornecedor === true) &&
                        (codStatusMedicao === 1 || codStatusMedicao === 3 || codStatusMedicao === 14)))
                  ) {
                    return (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={() => toggleEdit(record)}>
                        {(record.qt_bl_periodo === '' || record.qt_bl_periodo == "0,000") ? <> Incluir Valor </> : record.qt_bl_periodo}
                      </div>
                    );
                  } else {
                    return (
                      <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }}>
                        {record.qt_bl_periodo}
                      </div>
                    );
                  }
                }
              } else {
                return <> {record.qt_bl_periodo}</>;
              }
            },
          },
          {
            title: 'Anterior',
            dataIndex: 'qt_bl_anterior',
            key: 'qt_bl_anterior',
            className: 'quantidade-boletim-medicao-coluna',
          },
          {
            title: 'Acumulado',
            dataIndex: 'qt_bl_acumulado',
            key: 'qt_bl_acumulado',
            className: 'quantidade-boletim-medicao-coluna',
          },
          {
            title: 'QTD Total',
            dataIndex: 'quantidade',
            key: 'quantidade',
            className: 'quantidade-boletim-medicao-coluna',
          },
          {
            title: 'Saldo',
            dataIndex: 'qt_bl_saldo',
            key: 'qt_bl_saldo',
            className: 'quantidade-boletim-medicao-coluna',
          },
        ],
      });
    } else {
      novaColumsMedicao.push({
        //title: 'QTD BM',
        className: 'quantidade-boletim-medicao-coluna',
        title: column => {
          return (
            <>
              QTD BM
              <Tooltip title={showCollunsTabelaMedicao ? 'Contrair Colunas' : 'Expandir Colunas'}>
                <Button
                  onClick={() => {
                    setShowCollunsTabelaMedicao(!showCollunsTabelaMedicao);
                  }}
                  name="btnMostrarEsconder"
                  title={showCollunsTabelaMedicao ? '' : ''}
                  type="link"
                  icon={showCollunsTabelaMedicao ? columnRemove : columnAdd}
                />
              </Tooltip>
            </>
          );
        },
        children: [
          {
            title: 'Período',
            dataIndex: 'qt_bl_periodo',
            key: 'qt_bl_periodo',
            className: 'quantidade-boletim-medicao-coluna',
            render: (text, record, index) => {
              if (
                record.editable === true &&
                record.usuarioPodeAlterarDados === true &&
                (codStatusMedicao === 1 ||
                  codStatusMedicao === 3 ||
                  (codStatusMedicao === 5 && record.incontroverso) ||
                  codStatusMedicao === 7 ||
                  codStatusMedicao === 8 ||
                  codStatusMedicao === 9 ||
                  codStatusMedicao === 10 ||
                  codStatusMedicao === 11 ||
                  codStatusMedicao === 12 ||
                  codStatusMedicao === 13 ||
                  codStatusMedicao === 14)
              ) {
                if (
                  editAnterior &&
                  record.id === idEdit &&
                  hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) &&
                  (usuarioLogadoGestorDoContratoMrn === true ||
                    usuarioLogadoFiscalDoContratoMrn === true ||
                    usuarioLogadoTecnicoMedicaoMrn === true ||
                    usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
                    ((usuarioLogadoFiscalDoContratoFornecedor === true ||
                      usuarioLogadoGestorDoContratoFornecedor === true) &&
                      (codStatusMedicao === 1 || codStatusMedicao === 3 || codStatusMedicao === 14)))
                ) {
                  return (
                    <Input
                      name="qt_bl_periodo"
                      formatter={currencyFormat}
                      parser={currencyParser}
                      onBlur={() => cancelar()}
                      onPressEnter={e => save(record, e)}
                      defaultValue={record.qt_bl_periodo}
                      ref={node => {
                        setValorAlterado(node);
                      }}
                    />
                  );
                } else {
                  if (
                    hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) &&
                    (codStatusMedicao === 1 ||
                      codStatusMedicao === 3 ||
                      (codStatusMedicao === 5 && record.incontroverso) ||
                      codStatusMedicao === 7 ||
                      codStatusMedicao === 8 ||
                      codStatusMedicao === 9 ||
                      codStatusMedicao === 10 ||
                      codStatusMedicao === 11 ||
                      codStatusMedicao === 12 ||
                      codStatusMedicao === 13 ||
                      codStatusMedicao === 14) &&
                    (usuarioLogadoGestorDoContratoMrn === true ||
                      usuarioLogadoFiscalDoContratoMrn === true ||
                      usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
                      usuarioLogadoTecnicoMedicaoMrn === true ||
                      ((usuarioLogadoFiscalDoContratoFornecedor === true ||
                        usuarioLogadoGestorDoContratoFornecedor === true) &&
                        (codStatusMedicao === 1 || codStatusMedicao === 3 || codStatusMedicao === 14)))
                  ) {
                    return (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={() => toggleEdit(record)}>
                        {(record.qt_bl_periodo === '' || record.qt_bl_periodo == "0,000") ? <> Incluir Valor </> : record.qt_bl_periodo}
                      </div>
                    );
                  } else {
                    return (
                      <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }}>
                        {record.qt_bl_periodo}
                      </div>
                    );
                  }
                }
              } else {
                return <> {record.qt_bl_periodo}</>;
              }
            },
          },
        ],
      });
    }

    if (showCollunsTabelaMedicaoValor === true) {
      novaColumsMedicao.push({
        //title: 'Valor BM',
        title: column => {
          return (
            <>
              Valor BM
              <Tooltip title={showCollunsTabelaMedicaoValor ? 'Contrair Colunas' : 'Expandir Colunas'}>
                <Button
                  onClick={() => {
                    setShowCollunsTabelaMedicaoValor(!showCollunsTabelaMedicaoValor);
                  }}
                  name="btnMostrarEsconderValorBm"
                  title={showCollunsTabelaMedicaoValor ? '' : ''}
                  type="link"
                  icon={showCollunsTabelaMedicaoValor ? columnRemove : columnAdd}
                />
              </Tooltip>
            </>
          );
        },
        className: 'valor-boletim-medicao-coluna',
        children: [
          {
            title: 'Período',
            dataIndex: 'vl_bl_periodo',
            key: 'vl_bl_periodo',
            className: 'valor-boletim-medicao-coluna',
          },
          {
            title: 'Anterior',
            dataIndex: 'vl_bl_anterior',
            key: 'vl_bl_anterior',
            className: 'valor-boletim-medicao-coluna',
          },
          {
            title: 'Acumulado',
            dataIndex: 'vl_bl_acumulado',
            key: 'vl_bl_acumulado',
            className: 'valor-boletim-medicao-coluna',
          },
          {
            title: 'Verba Total',
            dataIndex: 'verbaTotal',
            key: 'verbaTotal',
            className: 'valor-boletim-medicao-coluna',
          },
          {
            title: 'Saldo',
            dataIndex: 'vl_bl_saldo',
            key: 'vl_bl_saldo',
            className: 'valor-boletim-medicao-coluna',
          },
          ,
        ],
      });
    } else {
      novaColumsMedicao.push({
        //title: 'Valor BM',
        title: column => {
          return (
            <>
              Valor BM
              <Tooltip title={showCollunsTabelaMedicaoValor ? 'Contrair Colunas' : 'Expandir Colunas'}>
                <Button
                  onClick={() => {
                    setShowCollunsTabelaMedicaoValor(!showCollunsTabelaMedicaoValor);
                  }}
                  name="btnMostrarEsconderValorBm"
                  title={showCollunsTabelaMedicaoValor ? '' : ''}
                  type="link"
                  icon={showCollunsTabelaMedicaoValor ? columnRemove : columnAdd}
                />
              </Tooltip>
            </>
          );
        },
        className: 'valor-boletim-medicao-coluna',
        children: [
          {
            title: 'Período',
            dataIndex: 'vl_bl_periodo',
            key: 'vl_bl_periodo',
            className: 'valor-boletim-medicao-coluna',
          },
        ],
      });
    }

    novaColumsMedicao.push({
      title: 'Evidências',
      className: 'table-centered-content evidencia-coluna',
      children: [
        {
          title: 'Anexos',
          className: 'table-centered-content',
          render: (text, record) => {
            if (record.editable === true && hasPermission(['MEDICAO_QUANTITATIVA_EDITAR', 'MEDICAO_VISUALIZAR_ANEXOS'])) {
              return (
                <>
                  <ModalAnexo
                    linhaBmId={record.id}
                    contemAnexo={record.contemAnexo}
                    usuarioLogadoGestorDoContratoFornecedor={usuarioLogadoGestorDoContratoFornecedor}
                    usuarioLogadoFiscalDoContratoFornecedor={usuarioLogadoFiscalDoContratoFornecedor}
                    codStatusMedicao={codStatusMedicao}
                  />
                </>
              );
            }
            return <> </>;
          },
        },
      ],
    });

    novaColumsMedicao.push({
      title: 'Análise',
      className: 'analise-coluna',
      children: [
        {
          title: 'Comentários',
          key: 'acoes',
          className: 'table-centered-content',
          render: (text, record) => {
            if (record.editable === true && hasPermission(['MEDICAO_QUANTITATIVA_EDITAR'])) {
              return (
                <>
                  <ModalComentario
                    linhaBmId={record.id}
                    contemComentario={record.contemComentario}
                  />
                </>
              );
            }
            return <> </>;
          },
        },
        {
          title: 'Resultado',
          key: 'resultado',
          className: 'table-centered-content',
          render: (text, record) => {
            if (
              record.editable === true &&
              codStatusMedicao != 4 &&
              codStatusMedicao != 8 &&
              codStatusMedicao != 7 &&
              codStatusMedicao != 9 &&
              hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) &&
              (usuarioLogadoGestorDoContratoMrn === true ||
                usuarioLogadoFiscalDoContratoMrn === true ||
                usuarioLogadoFiscalAlternativoDoContratoMrn === true)
            ) {
              return (
                <>
                  <Select
                    defaultValue={record.aprovadoString}
                    onChange={e => {
                      AprovarOuReprovar(record.id, e);
                      record.incontroverso = e === 'Incontroverso';
                    }}
                    style={{ width: 120 }}>
                    <Option value="0">Selecione</Option>
                    <Option value="Aprovado">Aprovado</Option>
                    <Option value="Reprovado">Reprovado</Option>
                    {codStatusMedicao === 5 &&
                      usuarioLogadoGestorDoContratoMrn === true &&
                      aprovadoComRessalva === true ? (
                      <Option value="Incontroverso">Incontroverso</Option>
                    ) : null}
                  </Select>
                </>
              );
            }
            return <> {record.aprovadoString != '0' ? record.aprovadoString : ''}</>;
          },
        },
      ],
    });

    return novaColumsMedicao;
  }, [
    recarregarBotoesGrid,
    editAnterior,
    btnExpandRows,
    showCollunsTabelaMedicao,
    showCollunsTabelaMedicaoValor,
    codStatusMedicao,
    usuarioLogadoGestorDoContratoMrn,
    usuarioLogadoFiscalDoContratoMrn,
    usuarioLogadoFiscalAlternativoDoContratoMrn,
    usuarioLogadoTecnicoMedicaoMrn,
    usuarioLogadoFiscalDoContratoFornecedor,
    usuarioLogadoGestorDoContratoFornecedor,
    aprovadoComRessalva,
  ]);

  useEffect(() => {
    var elemento = document.getElementById('divPrincipal') as HTMLElement | null;
    if (elemento) {
      var linhaPrincial = elemento.parentNode;
      if (linhaPrincial) {
        linhaPrincial.setAttribute('id', 'rowPrincipalPage');
      }
    }
  }, []);

  useEffect(() => {
    if (fullScreen) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.fullscreenElement !== null) document.exitFullscreen();
    }
  }, [fullScreen]);

  return (
    <>
      {
        <div
          id={'divPrincipal'}
          className={geralData.justificaAprovacaoResalva && getLoggedIsMRN() ? 'ressalva-enabled' : ''}>
          <TotalizadorMedicao
            valoresMedicaoAnterior={valoresMedicaoAnterior}
            valoresMedicaoPeriodo={valoresMedicaoPeriodo}
            valoresMedicaoAcumulado={valoresMedicaoAcumulado}
            valoresContratoCriacaoMedicao={valoresContratoCriacaoMedicao}
            valoreMedicaoSaldo={valoreMedicaoSaldo}
          />

          {geralData.justificaAprovacaoResalva && getLoggedIsMRN() ? (
            <Widget id={'widgetJustificativa'}>
              <MasterDetailForm initialValues={geralData}>
                <FormTextArea
                  label="Justificativa de aprovação com ressalva"
                  name="justificaAprovacaoResalva"
                  span={12}
                  rows={2}
                  disabled={true}
                />
              </MasterDetailForm>
            </Widget>
          ) : (
            <></>
          )}

          <Widget
            className={fullScreen ? 'janela-fullscreen' : ''}
            id={'widgetMedicao'}
            title={`Medição - ${moment(geralData.periodoInicio).format(dateFormat)} a ${moment(
              geralData.periodoFim,
            ).format(dateFormat)} - ${geralData.status ? geralData.status : ''}`}
            actions={pqActionMedicao}
            toolbar={
              <Icon
                key="1"
                name={!fullScreen ? 'header-expand' : 'header-contract'}
                onClick={() => {
                  setFullScreen(!fullScreen);
                }}
              />
            }>
            <PerfectScrollbar>
              <Table
                rowClassName={record => {
                  return record.children.length ? '' : 'level-last';
                }}
                onRow={record => {
                  return {
                    onClick: event => {
                      if (expandedRows.includes(record.id))
                        setExpandedRows(expandedRows.filter(element => element !== record.id));
                      else {
                        setExpandedRows([...expandedRows, record.id]);
                      }
                    },
                  };
                }}
                columns={columsMedicaoNovo}
                dataSource={getAllItensDaMedicoes}
                rowKey={'id'}
                expandedRowKeys={expandedRows}
                pagination={false}
                className="boletim-tabela-medicao"
                expandIcon={props => {
                  const expanded = !props.record.children.length
                    ? 'ant-table-row-spaced'
                    : props.expanded
                      ? 'ant-table-row-expanded'
                      : 'ant-table-row-collapsed';
                  return (
                    <div
                      className={`ant-table-row-expand-icon ${expanded}`}
                      onClick={e => {
                        if (expandedRows.includes(props.record.id))
                          setExpandedRows(expandedRows.filter(element => element !== props.record.id));
                        else {
                          setExpandedRows([...expandedRows, props.record.id]);
                        }
                        props.onExpand(props.record, e);
                      }}
                    />
                  );
                }}
              />
            </PerfectScrollbar>
          </Widget>
        </div>
      }
    </>
  );
};

export default Medicao;
